module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/9-86e9b9ba8d4c64fedecb6e5f745add32.png";